module.exports = __webpack_public_path__ + "img/logo.a852bdf0.png";